<template functional>
    <div class="hero">
        <div class="entryImage loadEffect"></div>
        <div class="blurredImage"></div>
    </div>
</template>

<script>
    export default {
        name: 'Hero',
        props: {
            currentArtwork: Object
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .hero {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 70vh;
        padding: 1.5rem 1rem 0 1rem;
    }

    .blurredImage {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: -2;
        background: var(--color-grey-150);

        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 80%;
            bottom: 0;
            left: 0;
            background: var(--gradient-black-0-black-1);
        }
    }

    .entryImage {
        height: 100%;
        max-width: 40rem;
        width: 100%;
        border-radius: 0.75rem;
    }

    @media all and (max-width: 800px) {
        .hero {
            padding: 1.5rem 0.5rem 0 0.5rem;
            height: 56vh;
        }
    }

    @media all and (max-width: 560px) {
        .hero {
            padding: 0;
        }

        .image {
            border-radius: 0 0 1rem 1rem;
        }
    }
</style>